import { Checkbox, Flex, Text } from '@chakra-ui/react';
import React from 'react';

interface Iprops {
  name: string;
  activeIndex: number;
  setIsCompleted: any;
  isCompleted: any;
  index: number;
  setActiveIndex: any;
  disableVid: any;
}

const Chapters = (props: Iprops) => {
  const {
    name,
    //  setIsCompleted,
    isCompleted,
    index,
    setActiveIndex,
    disableVid,
  } = props;

  return (
    <Flex
      height="35px"
      onClick={() => {
        disableVid !== 0 && setActiveIndex(index);
      }}
      alignItems="center"
      mb='4'
    >
      <Checkbox
        size="md"
        colorScheme="green"
        onChange={(e) => {
          //   setIsCompleted({ ...isCompleted, [index]: e.target.checked });
        }}
        // checked={}
        disabled={disableVid === 0}
        backgroundColor="#fff"
        isChecked={isCompleted}
      ></Checkbox>
      <Text fontSize='sm' cursor={disableVid !== 0 ? 'pointer' : 'not-allowed'} pl={3}>
        {' '}
        {name}
      </Text>
    </Flex>
  );
};

export default Chapters;
